import {
  tv
} from "./chunk-TX3FPB7D.mjs";

// src/components/form.ts
var form = tv({
  base: "flex flex-col gap-2 items-start"
});

export {
  form
};
